/**
 * Checks if the current window is in an iframe whose parent is a same-origin HubSpot domain.
 */
export function isInIframeInHubSpot() {
  try {
    if (window.parent === window.self) return false;
    return window.parent.location.origin === window.location.origin;
  } catch (_unused) {
    return false;
  }
}